import React from 'react';
import '../../../css/web/SectionBanner.css';
import {useTranslation} from "react-i18next";
import {Swiper, SwiperSlide} from "swiper/react";
import {Autoplay, EffectFade, Pagination} from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

/*
 * 메인 상단 히어로 배너 (4종)
 * - 기존 서버 이미지 슬라이드를 대체하는 신규 디자인 배너
 * - 모든 문구는 i18next 번역키(mbn*)로 매핑
 * - 일러스트는 인라인 SVG + CSS 키프레임 애니메이션으로 직접 구현
 * - 라이트/다크 테마는 SectionBanner.css 의 [data-theme="dark"] 규칙으로 대응
 * - Swiper fade 효과 + 자동재생, 슬라이드 활성화 시 내부 요소 등장 애니메이션
 */

/* 배너1 : 패킹 / 해외배송 / 비행기 컨셉 일러스트 */
function IllustShipping() {
    return (
        <svg className="mbn-illust" viewBox="0 0 320 260" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <circle className="mbn-orbit" cx="200" cy="120" r="96" stroke="#ffffff" strokeOpacity="0.35" strokeWidth="2" strokeDasharray="6 10"/>
            <g className="mbn-float-a">
                {/* 지구본 */}
                <circle cx="200" cy="120" r="60" fill="#FFE7C2"/>
                <circle cx="200" cy="120" r="60" fill="url(#mbnGlobe)"/>
                <path d="M158 108c22 8 50 8 84-2M150 128c30 10 66 8 98-6M170 150c22 6 44 6 66-2" stroke="#F6A94A" strokeWidth="3" strokeLinecap="round" opacity="0.8"/>
                <ellipse cx="200" cy="120" rx="22" ry="60" stroke="#F6A94A" strokeWidth="3" opacity="0.7"/>
            </g>
            {/* 택배 박스 */}
            <g className="mbn-float-b">
                <rect x="44" y="150" width="96" height="78" rx="10" fill="#FFB74A"/>
                <rect x="44" y="150" width="96" height="30" rx="10" fill="#FFCB74"/>
                <path d="M92 150v78" stroke="#E7952F" strokeWidth="4"/>
                <path d="M44 176h96" stroke="#E7952F" strokeWidth="3" opacity="0.6"/>
                <rect x="80" y="150" width="24" height="18" rx="4" fill="#fff" opacity="0.85"/>
            </g>
            {/* 비행기 */}
            <g className="mbn-plane">
                <path d="M232 46l40 8-14 16 6 26-10-4-8-16-16 8 2 12-9-3-3-19-15-9 12-6 4-14z" fill="#ffffff"/>
                <path d="M232 46l40 8-14 16-20-18z" fill="#FFE2B0"/>
            </g>
            <g className="mbn-spark">
                <circle cx="120" cy="70" r="4" fill="#fff"/>
                <circle cx="270" cy="150" r="5" fill="#fff" opacity="0.8"/>
                <circle cx="96" cy="120" r="3" fill="#fff" opacity="0.7"/>
            </g>
            <defs>
                <radialGradient id="mbnGlobe" cx="0.35" cy="0.3" r="0.8">
                    <stop stopColor="#FFF4E1"/>
                    <stop offset="1" stopColor="#FFD79A"/>
                </radialGradient>
            </defs>
        </svg>
    );
}

/* 배너2 : 모바일에서 배송사별 비교견적 결제 컨셉 */
function IllustCompare() {
    return (
        <svg className="mbn-illust" viewBox="0 0 320 260" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <g className="mbn-float-a">
                {/* 휴대폰 */}
                <rect x="104" y="26" width="128" height="212" rx="22" fill="#ffffff"/>
                <rect x="104" y="26" width="128" height="212" rx="22" fill="url(#mbnPhone)" fillOpacity="0.25"/>
                <rect x="114" y="44" width="108" height="176" rx="10" fill="#FFF6EA"/>
                <rect x="150" y="34" width="36" height="6" rx="3" fill="#EAD9C2"/>
                {/* 비교 리스트 카드 3개 */}
                <g className="mbn-list-a">
                    <rect x="124" y="58" width="88" height="34" rx="8" fill="#ffffff"/>
                    <circle cx="140" cy="75" r="8" fill="#FFB74A"/>
                    <rect x="154" y="68" width="30" height="6" rx="3" fill="#D8DEE8"/>
                    <rect x="154" y="79" width="46" height="6" rx="3" fill="#EDF0F5"/>
                </g>
                <g className="mbn-list-b">
                    <rect x="124" y="98" width="88" height="34" rx="8" fill="#ffffff" stroke="#FFB74A" strokeWidth="2"/>
                    <circle cx="140" cy="115" r="8" fill="#5AC77E"/>
                    <rect x="154" y="108" width="30" height="6" rx="3" fill="#C8CFDA"/>
                    <rect x="154" y="119" width="46" height="6" rx="3" fill="#EDF0F5"/>
                    <path d="M196 112l4 4 7-8" stroke="#5AC77E" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                </g>
                <g className="mbn-list-c">
                    <rect x="124" y="138" width="88" height="34" rx="8" fill="#ffffff"/>
                    <circle cx="140" cy="155" r="8" fill="#7C9EDC"/>
                    <rect x="154" y="148" width="30" height="6" rx="3" fill="#D8DEE8"/>
                    <rect x="154" y="159" width="46" height="6" rx="3" fill="#EDF0F5"/>
                </g>
                {/* 결제 버튼 */}
                <rect x="124" y="184" width="88" height="24" rx="12" fill="#FFAF34"/>
                <rect x="150" y="193" width="36" height="6" rx="3" fill="#ffffff"/>
            </g>
            {/* 떠다니는 카드 */}
            <g className="mbn-float-b">
                <rect x="26" y="150" width="78" height="50" rx="8" fill="#FFB74A"/>
                <rect x="26" y="164" width="78" height="10" fill="#E7952F"/>
                <rect x="34" y="182" width="30" height="6" rx="3" fill="#fff" opacity="0.9"/>
            </g>
            <g className="mbn-spark">
                <circle cx="60" cy="60" r="4" fill="#fff"/>
                <circle cx="270" cy="90" r="5" fill="#fff" opacity="0.85"/>
                <circle cx="256" cy="200" r="3" fill="#fff" opacity="0.7"/>
            </g>
            <defs>
                <linearGradient id="mbnPhone" x1="104" y1="26" x2="232" y2="238" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FFCB74"/>
                    <stop offset="1" stopColor="#FF9E2C"/>
                </linearGradient>
            </defs>
        </svg>
    );
}

/* 배너3 : 장바구니 / 간편 온라인쇼핑 컨셉 */
function IllustCart() {
    return (
        <svg className="mbn-illust" viewBox="0 0 320 260" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            {/* 장바구니 */}
            <g className="mbn-float-a">
                <path d="M70 96h150l-16 84a16 16 0 0 1-16 13H98a16 16 0 0 1-16-13L70 96z" fill="#FFB74A"/>
                <path d="M70 96h150l-4 22H74l-4-22z" fill="#FFCB74"/>
                <path d="M96 96c0-30 20-52 48-52s48 22 48 52" stroke="#ffffff" strokeWidth="6" strokeLinecap="round"/>
                {/* 담긴 상품 */}
                <g className="mbn-item-a"><rect x="98" y="126" width="34" height="34" rx="7" fill="#fff"/><circle cx="115" cy="143" r="8" fill="#FF8FA3"/></g>
                <g className="mbn-item-b"><rect x="142" y="126" width="34" height="34" rx="7" fill="#fff"/><rect x="150" y="134" width="18" height="18" rx="4" fill="#7C9EDC"/></g>
                <g className="mbn-item-c"><rect x="120" y="162" width="34" height="24" rx="6" fill="#fff"/><rect x="128" y="169" width="18" height="10" rx="3" fill="#5AC77E"/></g>
            </g>
            {/* 화살표 → 박스 */}
            <path className="mbn-arrow" d="M232 150h34m0 0l-10-9m10 9l-10 9" stroke="#ffffff" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"/>
            <g className="mbn-float-b">
                <rect x="256" y="118" width="56" height="64" rx="9" fill="#fff"/>
                <rect x="256" y="118" width="56" height="20" rx="9" fill="#FFE7C2"/>
                <path d="M284 118v64" stroke="#F0B15E" strokeWidth="3"/>
            </g>
            {/* 태그 */}
            <g className="mbn-tag">
                <path d="M40 60l30-6 26 26-30 30-26-26 0-24z" fill="#ffffff"/>
                <circle cx="58" cy="72" r="6" fill="#FFAF34"/>
            </g>
            <g className="mbn-spark">
                <circle cx="250" cy="60" r="4" fill="#fff"/>
                <circle cx="286" cy="214" r="4" fill="#fff" opacity="0.8"/>
            </g>
        </svg>
    );
}

/* 배너4 : 카드 등록 후 6자리 비밀번호 간편결제 컨셉 */
function IllustPay() {
    return (
        <svg className="mbn-illust" viewBox="0 0 320 260" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            {/* 카드 */}
            <g className="mbn-float-a">
                <rect x="58" y="52" width="176" height="112" rx="16" fill="url(#mbnCard)"/>
                <rect x="58" y="80" width="176" height="20" fill="#E7952F" opacity="0.55"/>
                <rect x="78" y="118" width="52" height="12" rx="4" fill="#ffffff" opacity="0.85"/>
                <rect x="78" y="136" width="90" height="8" rx="4" fill="#ffffff" opacity="0.5"/>
                <circle cx="204" cy="130" r="14" fill="#ffffff" opacity="0.8"/>
                <circle cx="190" cy="130" r="14" fill="#ffffff" opacity="0.5"/>
            </g>
            {/* 자물쇠 */}
            <g className="mbn-lock">
                <rect x="132" y="150" width="56" height="46" rx="10" fill="#ffffff"/>
                <path d="M144 150v-8a16 16 0 0 1 32 0v8" stroke="#FFAF34" strokeWidth="6" fill="none"/>
                <circle cx="160" cy="170" r="6" fill="#FFAF34"/>
                <rect x="157" y="174" width="6" height="12" rx="3" fill="#FFAF34"/>
            </g>
            {/* 6자리 비밀번호 점 */}
            <g className="mbn-dots" transform="translate(96 214)">
                <circle className="mbn-dot d1" cx="0" cy="0" r="9" fill="#ffffff"/>
                <circle className="mbn-dot d2" cx="26" cy="0" r="9" fill="#ffffff"/>
                <circle className="mbn-dot d3" cx="52" cy="0" r="9" fill="#ffffff"/>
                <circle className="mbn-dot d4" cx="78" cy="0" r="9" fill="#ffffff"/>
                <circle className="mbn-dot d5" cx="104" cy="0" r="9" fill="#ffffff"/>
                <circle className="mbn-dot d6" cx="130" cy="0" r="9" fill="#ffffff"/>
            </g>
            <g className="mbn-spark">
                <circle cx="266" cy="70" r="4" fill="#fff"/>
                <circle cx="46" cy="120" r="4" fill="#fff" opacity="0.8"/>
            </g>
            <defs>
                <linearGradient id="mbnCard" x1="58" y1="52" x2="234" y2="164" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FFC768"/>
                    <stop offset="1" stopColor="#FF922E"/>
                </linearGradient>
            </defs>
        </svg>
    );
}

function SectionBanner() {
    const {t} = useTranslation();

    return (
        <div className="mbn-wrap">
            <Swiper
                className="mbn-swiper"
                modules={[Autoplay, Pagination, EffectFade]}
                effect="fade"
                fadeEffect={{crossFade: true}}
                slidesPerView={1}
                loop={true}
                speed={900}
                autoplay={{delay: 5000, disableOnInteraction: false}}
                pagination={{clickable: true, dynamicBullets: true}}
            >
                {/* 배너 1 */}
                <SwiperSlide>
                    <div className="mbn-slide mbn-theme-1">
                        <div className="mbn-blob mbn-blob-1"/>
                        <div className="mbn-blob mbn-blob-2"/>
                        <div className="mbn-inner">
                            <div className="mbn-text">
                                <span className="mbn-badge">Btorage</span>
                                <h2 className="mbn-title">{t('mbn1Title')}</h2>
                                <div className="mbn-feature-row">
                                    <div className="mbn-feature"><b>{t('mbn1Faster')}</b><span>{t('mbn1FasterSub')}</span></div>
                                    <div className="mbn-feature"><b>{t('mbn1Easier')}</b><span>{t('mbn1EasierSub')}</span></div>
                                    <div className="mbn-feature"><b>{t('mbn1Cheaper')}</b><span>{t('mbn1CheaperSub')}</span></div>
                                    <div className="mbn-feature"><b>{t('mbn1Careful')}</b><span>{t('mbn1CarefulSub')}</span></div>
                                    <div className="mbn-feature"><b>{t('mbn1Smooth')}</b><span>{t('mbn1SmoothSub')}</span></div>
                                </div>
                                <p className="mbn-desc">{t('mbn1Desc')}</p>
                            </div>
                            <div className="mbn-art"><IllustShipping/></div>
                        </div>
                    </div>
                </SwiperSlide>

                {/* 배너 2 */}
                <SwiperSlide>
                    <div className="mbn-slide mbn-theme-2">
                        <div className="mbn-blob mbn-blob-1"/>
                        <div className="mbn-blob mbn-blob-2"/>
                        <div className="mbn-inner">
                            <div className="mbn-text">
                                <span className="mbn-badge">Compare &amp; Pay</span>
                                <h2 className="mbn-title">{t('mbn2Title')}</h2>
                                <p className="mbn-desc mbn-desc-lg">{t('mbn2Desc1')}</p>
                                <p className="mbn-desc mbn-desc-strong">{t('mbn2Desc2')}</p>
                            </div>
                            <div className="mbn-art"><IllustCompare/></div>
                        </div>
                    </div>
                </SwiperSlide>

                {/* 배너 3 */}
                <SwiperSlide>
                    <div className="mbn-slide mbn-theme-3">
                        <div className="mbn-blob mbn-blob-1"/>
                        <div className="mbn-blob mbn-blob-2"/>
                        <div className="mbn-inner">
                            <div className="mbn-text">
                                <span className="mbn-badge">Cart Order</span>
                                <h2 className="mbn-title">{t('mbn3Title')}</h2>
                                <div className="mbn-lines">
                                    <p>{t('mbn3Line1')}</p>
                                    <p><b>{t('mbn3Line2')}</b></p>
                                    <p>{t('mbn3Line3')}</p>
                                    <p><b>{t('mbn3Line4')}</b></p>
                                </div>
                                <p className="mbn-desc">{t('mbn3Desc')}</p>
                            </div>
                            <div className="mbn-art"><IllustCart/></div>
                        </div>
                    </div>
                </SwiperSlide>

                {/* 배너 4 */}
                <SwiperSlide>
                    <div className="mbn-slide mbn-theme-4">
                        <div className="mbn-blob mbn-blob-1"/>
                        <div className="mbn-blob mbn-blob-2"/>
                        <div className="mbn-inner">
                            <div className="mbn-text">
                                <span className="mbn-badge">Btorage Pay</span>
                                <h2 className="mbn-title">{t('mbn4Title')}</h2>
                                <p className="mbn-desc mbn-desc-lg">{t('mbn4Desc1')}</p>
                                <p className="mbn-desc mbn-desc-strong">{t('mbn4Desc2')}</p>
                            </div>
                            <div className="mbn-art"><IllustPay/></div>
                        </div>
                    </div>
                </SwiperSlide>
            </Swiper>
        </div>
    );
}

export default SectionBanner;
